// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function ChevronRight(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "ChevronRight" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M16.75 12L10.3964 5.64641L8.63309 7.40977L13.2133 12L8.63309 16.5902L10.3964 18.3535L16.75 12Z", fill: "currentColor" }))));
});
//# sourceMappingURL=ChevronRight.js.map